module.exports = __webpack_public_path__ + "static/media/impreza-hero.dc45aaef.webp";